/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PartnerSubscriptionTypeMappingDto as OkEgisServiceModelsDtoPartnerSubscriptionTypeMappingDto } from '../models/OK/Egis/Service/Models/DTO/partner-subscription-type-mapping-dto';
import { UpdatePartnerSubscriptionTypeMappingRequest as OkEgisServiceModelsRequestUpdatePartnerSubscriptionTypeMappingRequest } from '../models/OK/Egis/Service/Models/Request/update-partner-subscription-type-mapping-request';
import { UpdatePartnerSubscriptionTypeMappingResponse as OkEgisServiceModelsResponseUpdatePartnerSubscriptionTypeMappingResponse } from '../models/OK/Egis/Service/Models/Response/update-partner-subscription-type-mapping-response';

@Injectable({
  providedIn: 'root',
})
export class PartnerSubscriptionTypeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAllPartnerSubscriptionTypeMappings
   */
  static readonly GetAllPartnerSubscriptionTypeMappingsPath = '/api/v1/PartnerSubscriptionType/GetAllPartnerSubscriptionTypeMappings';

  /**
   * Returns a list of available partner-subscriptions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPartnerSubscriptionTypeMappings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPartnerSubscriptionTypeMappings$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerSubscriptionTypeMappingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerSubscriptionTypeService.GetAllPartnerSubscriptionTypeMappingsPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerSubscriptionTypeMappingDto>>;
      })
    );
  }

  /**
   * Returns a list of available partner-subscriptions.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllPartnerSubscriptionTypeMappings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPartnerSubscriptionTypeMappings(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoPartnerSubscriptionTypeMappingDto>> {

    return this.getAllPartnerSubscriptionTypeMappings$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerSubscriptionTypeMappingDto>>) => r.body as Array<OkEgisServiceModelsDtoPartnerSubscriptionTypeMappingDto>)
    );
  }

  /**
   * Path part for operation updatePartnerSubscriptionTypeMapping
   */
  static readonly UpdatePartnerSubscriptionTypeMappingPath = '/api/v1/PartnerSubscriptionType/UpdatePartnerSubscriptionTypeMapping';

  /**
   * Updates price on a partner-subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePartnerSubscriptionTypeMapping()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartnerSubscriptionTypeMapping$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdatePartnerSubscriptionTypeMappingRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseUpdatePartnerSubscriptionTypeMappingResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerSubscriptionTypeService.UpdatePartnerSubscriptionTypeMappingPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseUpdatePartnerSubscriptionTypeMappingResponse>;
      })
    );
  }

  /**
   * Updates price on a partner-subscription.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updatePartnerSubscriptionTypeMapping$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartnerSubscriptionTypeMapping(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdatePartnerSubscriptionTypeMappingRequest
  }): Observable<OkEgisServiceModelsResponseUpdatePartnerSubscriptionTypeMappingResponse> {

    return this.updatePartnerSubscriptionTypeMapping$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseUpdatePartnerSubscriptionTypeMappingResponse>) => r.body as OkEgisServiceModelsResponseUpdatePartnerSubscriptionTypeMappingResponse)
    );
  }

}
